import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import LoadingAction from "../themes/LoadingAction/LoadingAction";
import * as links from "../utils/links";

function PrivateRoute({ children, ...rest }) {
  const { authInfo, loading } = useContext<any>(AuthContext);
  const location = useLocation();
  const { isAuthenticated, dataUser } = authInfo;

  if (loading) {
    return <LoadingAction />;
  }
  const hasValidUser =
    isAuthenticated &&
    dataUser !== null &&
    typeof dataUser === "object" &&
    typeof dataUser.token === "string" &&
    dataUser.token.trim() !== "";

  if (hasValidUser) {
    return children;
  }

  const collaboratorRoute =
    location.pathname.includes("colaborador") ||
    dataUser?.key === "COLABORADOR";

  return (
    <Navigate
      replace
      to={collaboratorRoute
        ? links.COLABORADOR_SIGNIN
        : dataUser?.key === "ADMIN"
          ? links.ADMIN_SIGNIN
          : links.SIGNIN}
    />
  );
}

export default PrivateRoute;
